import React from 'react';

import { UiButton } from '@shared/ui/UiButton';

import cls from './PreviewerHeader.module.css';

interface IPreviewerHeader {
    decodeNameFile: string;
    canDelete: boolean;
    onHide: () => void;
    handleDownload: () => void;
    setDeleteConfirmModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const PreviewerHeader = ({
    decodeNameFile,
    canDelete,
    setDeleteConfirmModal,
    onHide,
    handleDownload,
}: IPreviewerHeader) => (
    <div className={cls.prevHeader} onClick={(event) => event.stopPropagation()}>
        <div className={cls.iconBack}>
            <UiButton
                onClick={onHide}
                className={cls.iconBackStart}
                variant="icon"
                startIcon={
                    <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M10.375 15.375H22.875C23.0408 15.375 23.1997 15.4408 23.3169 15.5581C23.4342 15.6753 23.5 15.8342 23.5 16C23.5 16.1658 23.4342 16.3247 23.3169 16.4419C23.1997 16.5592 23.0408 16.625 22.875 16.625H10.375C10.2092 16.625 10.0503 16.5592 9.93306 16.4419C9.81585 16.3247 9.75 16.1658 9.75 16C9.75 15.8342 9.81585 15.6753 9.93306 15.5581C10.0503 15.4408 10.2092 15.375 10.375 15.375Z"
                            fill="#F5F5F5"
                        />
                        <path
                            d="M10.6336 16L15.8174 21.1825C15.9348 21.2999 16.0007 21.459 16.0007 21.625C16.0007 21.791 15.9348 21.9501 15.8174 22.0675C15.7 22.1849 15.5409 22.2508 15.3749 22.2508C15.2089 22.2508 15.0498 22.1849 14.9324 22.0675L9.3074 16.4425C9.24919 16.3844 9.20301 16.3155 9.17151 16.2395C9.14 16.1636 9.12378 16.0822 9.12378 16C9.12378 15.9178 9.14 15.8364 9.17151 15.7605C9.20301 15.6845 9.24919 15.6156 9.3074 15.5575L14.9324 9.9325C15.0498 9.81514 15.2089 9.74921 15.3749 9.74921C15.5409 9.74921 15.7 9.81514 15.8174 9.9325C15.9348 10.0499 16.0007 10.209 16.0007 10.375C16.0007 10.541 15.9348 10.7001 15.8174 10.8175L10.6336 16Z"
                            fill="#F5F5F5"
                        />
                    </svg>
                }
            />
        </div>
        <div className={cls.prevHeaderName}>{decodeNameFile}</div>
        <div className={cls.prevHeaderIcons}>
            <UiButton
                className={cls.interfaceIcon}
                onClick={handleDownload}
                variant="icon"
                startIcon={
                    <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M6.625 18.375C6.79076 18.375 6.94973 18.4408 7.06694 18.5581C7.18415 18.6753 7.25 18.8342 7.25 19V22.125C7.25 22.4565 7.3817 22.7745 7.61612 23.0089C7.85054 23.2433 8.16848 23.375 8.5 23.375H23.5C23.8315 23.375 24.1495 23.2433 24.3839 23.0089C24.6183 22.7745 24.75 22.4565 24.75 22.125V19C24.75 18.8342 24.8158 18.6753 24.9331 18.5581C25.0503 18.4408 25.2092 18.375 25.375 18.375C25.5408 18.375 25.6997 18.4408 25.8169 18.5581C25.9342 18.6753 26 18.8342 26 19V22.125C26 22.788 25.7366 23.4239 25.2678 23.8928C24.7989 24.3616 24.163 24.625 23.5 24.625H8.5C7.83696 24.625 7.20107 24.3616 6.73223 23.8928C6.26339 23.4239 6 22.788 6 22.125V19C6 18.8342 6.06585 18.6753 6.18306 18.5581C6.30027 18.4408 6.45924 18.375 6.625 18.375Z"
                            fill="#F5F5F5"
                        />
                        <path
                            d="M15.5576 20.8175C15.6156 20.8757 15.6846 20.9219 15.7605 20.9534C15.8364 20.9849 15.9178 21.0011 16.0001 21.0011C16.0823 21.0011 16.1637 20.9849 16.2396 20.9534C16.3155 20.9219 16.3845 20.8757 16.4426 20.8175L20.1926 17.0675C20.3099 16.9501 20.3758 16.791 20.3758 16.625C20.3758 16.459 20.3099 16.2999 20.1926 16.1825C20.0752 16.0651 19.916 15.9992 19.7501 15.9992C19.5841 15.9992 19.4249 16.0651 19.3076 16.1825L16.6251 18.8663V7.875C16.6251 7.70924 16.5592 7.55027 16.442 7.43306C16.3248 7.31585 16.1658 7.25 16.0001 7.25C15.8343 7.25 15.6753 7.31585 15.5581 7.43306C15.4409 7.55027 15.3751 7.70924 15.3751 7.875V18.8663L12.6926 16.1825C12.5752 16.0651 12.416 15.9992 12.2501 15.9992C12.0841 15.9992 11.9249 16.0651 11.8076 16.1825C11.6902 16.2999 11.6243 16.459 11.6243 16.625C11.6243 16.791 11.6902 16.9501 11.8076 17.0675L15.5576 20.8175Z"
                            fill="#F5F5F5"
                        />
                    </svg>
                }
            />

            {canDelete && (
                <UiButton
                    className={cls.interfaceIcon}
                    onClick={() => setDeleteConfirmModal(true)}
                    variant="icon"
                    startIcon={
                        <svg
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M20.1667 24.3333H11.8333C10.9129 24.3333 10.1667 23.5871 10.1667 22.6667V11.8333H8.5V10.1667H11.8333V9.33334C11.8333 8.41286 12.5795 7.66667 13.5 7.66667H18.5C19.4205 7.66667 20.1667 8.41286 20.1667 9.33334V10.1667H23.5V11.8333H21.8333V22.6667C21.8333 23.5871 21.0871 24.3333 20.1667 24.3333ZM11.8333 11.8333V22.6667H20.1667V11.8333H11.8333ZM13.5 9.33334V10.1667H18.5V9.33334H13.5ZM18.5 21H16.8333V13.5H18.5V21ZM15.1667 21H13.5V13.5H15.1667V21Z"
                                fill="#E04E2A"
                            />
                        </svg>
                    }
                />
            )}
        </div>
    </div>
);
